import apiClient, {authHeaders} from './config.js';

export default {
  // servicio para obtener 
  async getDocumentDomains(token) {
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.get('documents/document_domains');
  },
  async getDocuments(token, pageSize, page, searchQuery) {    
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Accept'] = 'application/json',
      config.headers.get['Content-Type'] =  'application/json'
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.get(`documents/?skip=${page}&limit=${pageSize}&search=${searchQuery}`, authHeaders(token));
  },
  async saveDocument(documentData, token) {
    const formData = new FormData();
    const { file, ...documentDataWithoutFile } = documentData;
    if (file) formData.append('file', file);
    Object.keys(documentDataWithoutFile).forEach(key => {
        const value = documentDataWithoutFile[key];
        console.log(`${key}: ${value}`);
        formData.append(key, value);
    });
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }, ...config.headers };
      return config;
    });
    return await apiClient.post('documents/save_document', formData);
  },
  async updateDocument(documentData, token) {
    const formData = new FormData();
    const { file, ...documentDataWithoutFile } = documentData;
    if (file) formData.append('file', file);
    Object.keys(documentDataWithoutFile).forEach(key => {
      formData.append(key, documentDataWithoutFile[key]);
    });
    return await apiClient.post('documents/update_document', formData, authHeaders(token));
  },
  // Servicio para eliminar un documento
  async deleteDocument(token, documentId) {    
    apiClient.interceptors.request.use((config) => {
      config.headers.get['Authorization'] = `Bearer ${token}`;
      return config;
    });
    return await apiClient.delete(`documents/${documentId}`, authHeaders(token));
  },
  // Servicio para obtener el detalle del documento
  async getDocumentDetail(documentId, token) {
    return await apiClient.get(`documents/${documentId}/detail`, authHeaders(token));
  },
};
